// removed by extract-text-webpack-plugin
module.exports = {"inputWrapper":"Profile__inputWrapper__ERZli","fileInput":"Profile__fileInput__1NEYI","profilePage":"Profile__profilePage__1CnPu","main":"Profile__main__e5GLt","sideMenu":"Profile__sideMenu__2hUhV","profile":"Profile__profile__1TMWI","profilecard":"Profile__profilecard__2LdsJ","info":"Profile__info__1BPGO","button":"Profile__button__39tBp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/profile/Profile.css
// module id = 6057
// module chunks = 0